/**
 * useCarouselDraft.js — the Carousel Composer's per-user autosave.
 *
 * One row per person, holding references only: the slide layout and which
 * HDPhotoHub shoots it came from. Restoring re-pulls the photos from the
 * delivery library, so nothing image-shaped is ever stored on the server.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

const KEY = ['carousel-draft'];

export function useCarouselDraft(enabled = true) {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get('/carousel-draft'),
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}

// Deliberately does not invalidate: this fires every few seconds while you work,
// and the answer is what we just sent.
export function useSaveCarouselDraft() {
  return useMutation({ mutationFn: (body) => api.put('/carousel-draft', body) });
}

export function useClearCarouselDraft() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.del('/carousel-draft'),
    onSuccess: () => qc.setQueryData(KEY, (prev) => ({ ...(prev || {}), draft: null })),
  });
}
